import {
    SERVICE_ADD,
    SERVICE_EDIT,
    SERVICE_REMOVE,
    ServiceAction,
    IServiceState,
    IServicesState,
} from "./types";
import ServiceAPI from "../../api/service";
import { ServiceSettings } from "../../settings/services";

// ------ STATE ------ //

const initialState: IServicesState = {
    myActiveServices: [],
    allServices: {}
}

// ----- REDUCER ----- //

export default function serviceReducer(state = initialState, action: ServiceAction) : IServicesState
{
    switch(action.type)
    {
        case SERVICE_ADD:
            return addService(state, action.serviceState);//action.id, action.userId, action.name, action.serviceType, action.properties, action.createdAt);
        case SERVICE_EDIT:
            return editService(state, action.serviceState);//action.id, action.userId, action.name, action.properties);
        case SERVICE_REMOVE:
            return removeService(state, action.id, action.userId);
        default:
            return state;
    }
}

// ----- ACTIONS ----- //

function addService(state: IServicesState, newService: IServiceState)// id: string, userId: string, name: string, serviceType: string, properties: IProperty[], createdAt: string) : ServicesState
{
    /*
    const serviceSetting = ServiceSettings.getDefaultState(newService.serviceType);
    newService = {
        ...serviceSetting,
        ...newService
    }
    console.log(newService);
*/
    return {
        myActiveServices: [
            ...state.myActiveServices,
            mergeWithDefaultState(newService)
        ],
        allServices : {
            ...state.allServices,
            [newService.userId]: state.allServices[newService.userId] ? [
                ...state.allServices[newService.userId],
                newService
            ] : [
                newService
            ]
        }
    };
}

function editService(state: IServicesState, editedService: IServiceState)// id: string, userId: string, name: string, properties: IProperty[]) : ServicesState
{
    const serviceSetting = ServiceSettings.getSettings(editedService.serviceType);
    const updatedServices = state.myActiveServices.map(service => {
        return service.id === editedService.id ? {
            ...serviceSetting,
            ...editedService
        } as IServiceState : service
    });

    return {
        myActiveServices: updatedServices,
        allServices : {
            ...state.allServices,
            [editedService.userId]: updatedServices
        }
    };
}

function removeService(state: IServicesState, id: string, userId: string) : IServicesState
{
    const updatedServices = state.myActiveServices.filter(service => {
        return service.id !== id;
    });

    return {
        myActiveServices: updatedServices,
        allServices: {
            ...state.allServices,
            [userId]: updatedServices
        }
    };
}

// ------ LOADER ----- //

export function loadServices(servicesState: IServicesState)
{
    return ServiceAPI.getAllServices().then((allServicesData: {[id: string]: IServiceState[]}) => {
        return ServiceAPI.getActiveServices().then((activeServices: IServiceState[]) => {
            return {
                myActiveServices: activeServices.map(service => mergeWithDefaultState(service)),
                allServices: Object.keys(allServicesData).reduce((map: any, key: string)=>{
                    const serviceState = allServicesData[key];
                    map[key] = serviceState.map(service => mergeWithDefaultState(service));
                    return map;
                }, {})
            };
        });
    }).catch((err: Error)=>{
        console.log(err);
        return {
            ...servicesState
        }
    });
}

// ------ HELPER ----- //

const mergeWithDefaultState = (service: IServiceState): IServiceState => {
    const defaultState = ServiceSettings.getDefaultState(service.serviceType) as IServiceState;
    return {
        ...defaultState,
        ...service,
        properties: service.properties.map(prop=>{
            let defaultProp = defaultState.properties.find(defaultProp=>prop.id===defaultProp.id) ?? {
                temporary: true
            };
            return {
                ...defaultProp,
                ...prop
            }
        })
    }
}

// -------------------- //